"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipArrow = exports.Tooltip = exports.StyledTooltip = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const PopoverArrow_1 = require("./PopoverArrow");
const TooltipBase_1 = require("./TooltipBase");
exports.StyledTooltip = styled_1.default(TooltipBase_1.TooltipBase) `
  background-color: ${styled_tools_1.prop('theme.gray5')};
  border-color: ${styled_tools_1.prop('theme.gray5')};
  color: ${styled_tools_1.prop('theme.gray0')};
  padding: 8px;
`;
function Tooltip(props) {
    return React.createElement(exports.StyledTooltip, Object.assign({ fade: true, slide: true }, props));
}
exports.Tooltip = Tooltip;
exports.TooltipArrow = PopoverArrow_1.PopoverArrow;

//# sourceMappingURL=Tooltip.js.map
